import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../lib/ep.js';

import LeveledHTMLText from '../front/helpers/LeveledHTMLText.js';
import VideoEmbed from '../front/VideoEmbed';

const PromotionExpired = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props?.promotion?.Promotion ?? {}
	const promo_c = promotion.config;

	const has_image_header = (isNotEmpty(promo_c, 'expired_image')) ? true : false;
	const has_video_header = (!has_image_header && promo_c.expired_video && promo_c.expired_video.url) ? true : false;

	const default_expired_message = `<h1>${i18n("This promotion has expired")}</h1>`;
	const expired_message = (isNotEmpty(promo_c, 'expired_description')) ? promo_c.expired_description : default_expired_message;

	return (
		<div class="layout_conts">
			<div class="flex_cols">
				{(has_image_header || has_video_header) ? (
					<div class="flex_col col_1">
						<div>
							{(has_image_header) && (
								<img src={promo_c.full_expired_image} style={{maxWidth:'100%'}} />
							)}

							{(has_video_header) && (
								<VideoEmbed
									video_url={promo_c.expired_video.url}
									video_thumb={promo_c.expired_video.image}
									autoplay={false}
								/>
							)}
						</div>
					</div>
				) : (
					<div class="flex_col col_1 iconed_media gui_main_text_color_on_bg">
						<div class="main_media_flex">
							<span class="icon knk-zipped"></span>
						</div>
					</div>
				)}

				<div class="flex_col col_2">
					{/* XEERPA PIXEL GOES HERE */}
					<div
						class="register_form_flex"
						style={{
							width:'100%',
							'--text-text-align':'center',
							'--h1-text-align':'var(--text-text-align)',
							'--p-text-align':'var(--text-text-align)',
						}}
					>
						<LeveledHTMLText
							_class={{ other:'gui_main_text_color_on_bg' }}
						>{expired_message}</LeveledHTMLText>
					</div>
				</div>
			</div>
		</div>
	)
};

export default injectIntl(PromotionExpired);